import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { CloseButton } from '../CloseButton';
import { useDevice } from '../Device';
import styles from './CustomModal.module.scss';
export function CustomModal(props) {
    const { children, className, footer, header, style, minWidth, maxWidth = 1198, mobileMaxWidth = '90%', minHeight, maxHeight = '90vh', width, height, hideCloseBtn, onClose, disableContentScroll = false, fullSizeHeader = false, headerClassName, disableFooterPadding, contentUseFullWidth = false, testId } = props, rest = _object_without_properties(props, [
        "children",
        "className",
        "footer",
        "header",
        "style",
        "minWidth",
        "maxWidth",
        "mobileMaxWidth",
        "minHeight",
        "maxHeight",
        "width",
        "height",
        "hideCloseBtn",
        "onClose",
        "disableContentScroll",
        "fullSizeHeader",
        "headerClassName",
        "disableFooterPadding",
        "contentUseFullWidth",
        "testId"
    ]);
    const { isMobileDevice } = useDevice();
    const renderedStyle = useMemo(()=>_object_spread_props(_object_spread({}, style), {
            minWidth,
            maxWidth: isMobileDevice ? mobileMaxWidth : maxWidth,
            minHeight,
            maxHeight,
            height,
            width
        }), [
        style,
        minWidth,
        maxWidth,
        mobileMaxWidth,
        minHeight,
        maxHeight,
        height,
        width,
        isMobileDevice
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, rest), {
        style: renderedStyle,
        className: cn(styles.root, {
            [styles.withHeader]: header
        }, className),
        "data-testid": testId,
        children: [
            !hideCloseBtn && /*#__PURE__*/ _jsx(CloseButton, {
                className: styles.closeBtn,
                skin: "transparent",
                testId: testId && "".concat(testId, "-close-btn"),
                onClick: onClose
            }),
            header && /*#__PURE__*/ _jsx("div", {
                className: cn(styles.header, {
                    [styles.fullSizeHeader]: fullSizeHeader
                }, headerClassName),
                children: header
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.content, {
                    [styles.disableOverflow]: disableContentScroll,
                    [styles.contentUseFullWidth]: contentUseFullWidth
                }),
                children: children
            }),
            footer && /*#__PURE__*/ _jsx("div", {
                className: cn(styles.footer, {
                    [styles.disablePadding]: disableFooterPadding
                }),
                children: footer
            })
        ]
    }));
}
